<template>
    <div class="bulk-provider-select">
        <requests-edit-table
            v-bind:requests="allRequests"
            v-bind:options="options"
            v-bind:group-by="isListMode ? 'provider' : 'placeholder'"
            v-bind:show-status-filter="true"
            v-bind:show-label="false"
        ></requests-edit-table>

        <div class="bulk-recipients-wrapper">
            <edit-table
                class="bulk-recipients is-mobile-scrollable"
                v-bind:rows="recipientRows"
                v-bind:columns="recipientColumns"
                v-bind:load="false"
                v-bind:load-options="false"
                v-bind:delete-row="false"
                v-bind:footer="false"
                v-bind:hide-filter-row="true"
                v-bind:is-zebra="false"
                v-bind:name="{ singular: 'Empfänger', plural: 'Empfänger' }"
            >
                <template v-slot:provider="{ row }">
                    <b class="is-truncated" v-bind:title="row.provider.name">{{ row.provider.name }}</b><template v-if="row.isAgency">&nbsp;(Agentur)</template>
                </template>

                <template v-slot:requestsInfo="{ row }">
                    <span class="is-truncated" v-bind:title="groupRequestInfo(row)">{{ groupRequestInfo(row) }}</span>
                </template>

                <template v-slot:contact="{ row }">
                    <multiselect
                        v-bind:value        = "bulkGroupContact(row)"
                        v-bind:options      = "contactOptions(row)"
                        v-bind:custom-label = "contactLabel"
                        v-bind:allow-empty  = "false"
                        track-by    = "email"
                        v-bind:placeholder  = "bulkGroupContact(row) ? 'Kontakt wählen' : 'Kein Kontakt mit Email!'"
                        v-on:input  = "contact => setContact(row, contact)"
                    ></multiselect>
                </template>
            </edit-table>
        </div>
    </div>
</template>



<script>
import EditTable from '@components/EditTable/Index.vue';
import RequestsEditTable from './RequestsEditTable';
import { Multiselect } from '@components/form';
import { dayMonth, compareDates } from '@utilities/functions';


export default {
    props: {
        options: {}
    },


    data: function () {
        return {
            recipientColumns: [
                { key: 'provider',     label: 'Leistungsträger', class: 'is-250px-cell is-pure-text has-border', sortable: false },
                { key: 'requestsInfo', label: 'Leistungen',      class: 'is-pure-text has-border is-grow-cell', sortable: false },
                { key: 'contact',      label: 'Kontakt',         class: 'is-340px-cell is-contact-cell', sortable: false }
            ]
        }
    },


    computed: {
        allRequests: function () {
            return this.$store.state.providers.reduce((requests, providerItem) => requests.concat(providerItem.requests), []);
        },

        bulkGroups: function () {
            return this.$store.getters.bulkGroups;
        },

        bulkGroupContact: function () {
            return this.$store.getters.bulkGroupContact;
        },

        isListMode: function () {
            return this.$store.state.bulkListMode;
        },

        //EditTable braucht Zeilen mit id — Kontakt-Auswahl läuft über contactKey in den Store.
        //Listen-Modus: eine Zeile (und ein Kontakt) pro Leistungsträger, auch wenn je Reise eine eigene Email rausgeht
        recipientRows: function () {
            const rows = [];
            this.bulkGroups.forEach(group => {
                const row = rows.find(item => item.id === group.contactKey);
                if (row) {
                    row.requests = row.requests.concat(group.requests);
                    row.emailCount++;
                } else {
                    rows.push({ ...group, id: group.contactKey, emailCount: 1 });
                }
            });
            return rows;
        }
    },


    methods: {
        groupRequestInfo: function (group) {
            const dates = [...group.requests]
                .sort((a, b) => compareDates(a.info.startAt, b.info.startAt))
                .map(request => dayMonth(request.info.startAt))
                .join(', ');
            const emails = group.emailCount > 1 ? ' in ' + group.emailCount + ' Emails (je Reise eine)' : '';
            return group.requests.length + ' Leistung' + (group.requests.length > 1 ? 'en' : '') + emails + ' (' + dates + ')';
        },

        contactOptions: function (group) {
            const options = (group.provider.contacts || []).filter(contact => contact.email);

            //requestContacts ergänzen, falls sie nicht in den Provider-Kontakten stehen
            group.requests.forEach(request => {
                if (request.requestContact && request.requestContact.email &&
                    options.findIndex(contact => contact.email === request.requestContact.email) === -1
                ) {
                    options.push(request.requestContact);
                }
            });

            return options;
        },

        contactLabel: function (contact) {
            const name = [contact.firstName, contact.lastName].filter(Boolean).join(' ');
            return name ? name + ' - ' + contact.email : contact.email;
        },

        setContact: function (group, contact) {
            this.$store.commit('setBulkContact', { feID: group.contactKey, contact });
        }
    },


    created: function () {
        //keine Vorauswahl — der Nutzer wählt bewusst aus (Status-Filter + "Sichtbare auswählen");
        //im Listen-Modus kommt die Auswahl aus der Liste und bleibt stehen
        if (!this.$store.state.bulkListMode) {
            this.$store.state.requestsSelected = [];
        }
    },


    components: {
        EditTable,
        RequestsEditTable,
        Multiselect
    }
}
</script>
